import MainButton from '@/components/Buttons/MainButton';
import { notify } from '@/utils/notify';
import AlertIcon from '@/components/Notifications/AlertIcon';
import NotifyWrapper from '@/components/Notifications/NotifyWrapper';
import React from 'react';
import { cartStore } from '@/stores/cart.store';
import { modalStore } from '@/stores/modal.store';
import useUserStore from '@/stores/user.store';
import { WITHDRAW_RESTRICTION_DEFAULT_TEXT } from '@/utils/constants';

interface Props {
    total: string;
}

const WithdrawFooter = ({ total }: Props) => {
    const { clearCart } = cartStore((state) => state);
    const { close } = modalStore((state) => state);
    const { fetchUser } = useUserStore((state) => state);

    const disabled = Number(total) == 0;

    async function withdraw() {
        await fetchUser();
        const freshUser = useUserStore.getState().user;
        notify(
            'error',
            <AlertIcon />,
            <NotifyWrapper
                title={'Error'}
                text={freshUser.withdrawRestrictionText || WITHDRAW_RESTRICTION_DEFAULT_TEXT}
            />,
            10000
        );
        clearCart();
        close();
    }

    return (
        <MainButton
            text={'WITHDRAW'}
            onClick={withdraw}
            disabled={disabled}
            background={disabled ? '#9D9D9D' : ''}
            className={`w-full text-white bg-blue`}
        />
    );
};

export default WithdrawFooter;
